import React, { useMemo } from 'react';
import cx from 'classnames';
import PropTypes from 'prop-types';

import { SiteConfigManager, usePreferences } from '@atlas/core';
import { ViewportDisplayController } from '@atlas/ui';

import MarketTypeSelector from 'common/MarketTypeSelector/MarketTypeSelector';
import categoryShape from 'common/PropTypes/categoryShape';
import SeoPageText from 'components/SeoPage/SeoPageText';

import ExpandableCategoryTournaments from '../Prematch/ExpandableCategoryTournaments';

const CategoryPlaceholder = React.forwardRef((props, ref) => {
  const { counter = 0 } = props;

  const style = {
    height: `${counter * 160 + 48}px`,
  };

  return <div className="category placeholder" ref={ref} style={style} />;
});

export const LiveCategoriesList = ({
  categories,
  clickedCategory,
  expandedCategory,
  forceIsExpanded,
}) => {
  const { getFavoriteCategories, preferences } = usePreferences();

  const sortedCategories = useMemo(
    () => getFavoriteCategories(categories),
    [categories, preferences],
  );

  const mainMarketsChoice = SiteConfigManager.getConfig(
    'config.config.sportsbook.mainMarketsChoice',
  );

  return (
    <>
      {mainMarketsChoice && <MarketTypeSelector />}
      <div className={cx('category-container', 'categories')}>
        {sortedCategories.map((category, i) => {
          const { id, liveCount } = category;

          const forceExpand = (forceIsExpanded && i === 0) ?? i === 0;

          return (
            <ViewportDisplayController
              counter={liveCount}
              key={id}
              placeholder={CategoryPlaceholder}
            >
              <ExpandableCategoryTournaments
                category={category}
                clickedCategory={clickedCategory}
                expandedCategory={expandedCategory}
                forceIsExpanded={forceExpand}
              />
            </ViewportDisplayController>
          );
        })}
      </div>
      <SeoPageText />
    </>
  );
};

LiveCategoriesList.propTypes = {
  categories: PropTypes.arrayOf(categoryShape).isRequired,
  clickedCategory: PropTypes.func,
  isAllExpanded: PropTypes.bool,
};
